<template>
  <div class="pembayaran">
    <SOSlotBase :container-name="'pembayaran'" :isLoading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Pembayaran'" :type="'back'" @back="back" />
      </template>
      <template v-slot:content>
        <div class="p-x-20">
          <div class="f-16 f-regular f-c-primary p-y-16">
            <p class="m-d-0">
              Anda akan melakukan pembayaran training sebesar
              <span style="font-weight: bold">
                Rp {{ formattedHargaTraining }}</span
              >
              untuk akun
              <span style="font-weight: bold">{{ dataOwner.email }}</span>
            </p>
            <p class="m-d-0" style="color: #da1e28; margin-top: 16px">
              Pastikan akun smartlink sudah sesuai. Jangan bayar sebelum
              <span style="font-weight: bold"
                >klik tombol Buat Tagihan {{ formatRupiah(hargaLengkap) }}</span
              >
            </p>
          </div>
        </div>
        <hr />
        <template v-if="formJadwal.pembayaran.kode_promo == ''">
          <FieldPromo></FieldPromo>
        </template>

        <template v-if="formJadwal.pembayaran.kode_promo != ''">
          <template v-if="showAlert">
            <div class="p-x-20">
              <div class="alert-success fade show p-x-20 p-y-20" role="alert">
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                  @click="closeAlert"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <p>Yeay! Selamat, Kamu Mendapatkan</p>
                <strong> 1. Diskon {{ promo[0].diskon }}%</strong>
              </div>
            </div>
          </template>
        </template>

        <div class="p-x-20 m-t-16 m-d-20 w-limit mod">
          <label
            class="f-Overpass f-14 f-c-black remove-margin require"
            style="font-weight: bolder"
            >Catat Sebagai Biaya Dari Akun</label
          >
          <Select2
            class="test-select fl-is-required inputs"
            id="select2"
            :options="dataAkun"
            :settings="{ placeholder: 'Pilih Akun' }"
            v-model="listAkun"
          />
        </div>
        <hr style="width: 95%; margin: 0 auto; margin-top: 16px" />
        <div class="p-x-20 p-t-16">
          <div class="form-control" style="height: max-content">
            <label
              for="viaBank"
              class="p-x-20 p-t-16 d-flex-align-center menu-1"
            >
              <input
                type="radio"
                name="metode_pembayaran"
                value="1"
                id="viaBank"
                @click="selectRadio(1)"
                :checked="selectedRadio === 1"
              />
              <div class="text" style="margin-left: 16px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.75 3H3.25C2.2835 3 1.5 3.7835 1.5 4.75V11.25C1.5 12.2165 2.2835 13 3.25 13H12.75C13.7165 13 14.5 12.2165 14.5 11.25V4.75C14.5 3.7835 13.7165 3 12.75 3Z"
                    stroke="#545454"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.5 6H14.5M4 9.375H5.5V10H4V9.375Z"
                    stroke="#545454"
                    stroke-width="1.40625"
                    stroke-linejoin="round"
                  />
                </svg>
                <label
                  class="f-Overpass f-14 f-c-black remove-margin"
                  style="font-weight: bolder; margin-left: 3px"
                >
                  Via Transfer Bank (BNI, BCA)</label
                >
                <div class="text-sub">
                  Biaya Administrasi Rp 10 - Rp 99 Proses Pengecekan (Approval
                  Maks 1 Jam 5 menit)
                </div>
              </div>
            </label>
            <hr style="width: 95%; margin: 0 auto" />
            <label for="viaQR" class="p-x-20 p-t-16 d-flex-align-center menu-2">
              <input
                type="radio"
                name="metode_pembayaran"
                value="2"
                id="viaQR"
                @click="selectRadio(2)"
              />
              <div class="text" style="margin-left: 16px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.75 3H3.25C2.2835 3 1.5 3.7835 1.5 4.75V11.25C1.5 12.2165 2.2835 13 3.25 13H12.75C13.7165 13 14.5 12.2165 14.5 11.25V4.75C14.5 3.7835 13.7165 3 12.75 3Z"
                    stroke="#545454"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.5 6H14.5M4 9.375H5.5V10H4V9.375Z"
                    stroke="#545454"
                    stroke-width="1.40625"
                    stroke-linejoin="round"
                  />
                </svg>
                <label
                  class="f-Overpass f-14 f-c-black remove-margin"
                  style="font-weight: bolder; margin-left: 3px"
                  >Via QRIS (Scan)
                  <span
                    style="
                      color: #24a148;
                      font-family: Overpass;
                      font-size: 9px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 150%; /* 13.5px */
                      letter-spacing: -0.18px;
                    "
                    >Tercepat</span
                  ></label
                >
                <div class="text-sub">
                  Biaya Administrasi 0.2% (Rp {{ hargaAdminDisplay }})
                  Pengecekan Otomatis, Langsung Masuk Gopay, OVO, DANA,
                  ShopeePay, M-BCA, Mandiri, BRI dan Semua Bank serta E-Wallet
                  yang support QRIS (Approval Maks 30 Menit)
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="p-x-20 btn_menu">
          <button
            type="button"
            class="btn btn-outline-primary btn-long"
            id="buttonkembali"
            @click="back()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 4.79289C13.0976 5.18342 13.0976 5.81658 12.7071 6.20711L7.41421 11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H7.41421L12.7071 18.7929C13.0976 19.1834 13.0976 19.8166 12.7071 20.2071C12.3166 20.5976 11.6834 20.5976 11.2929 20.2071L4.29289 13.2071C3.90237 12.8166 3.90237 12.1834 4.29289 11.7929L11.2929 4.79289C11.6834 4.40237 12.3166 4.40237 12.7071 4.79289Z"
                fill="#206CFF"
              />
            </svg>
            Kembali
          </button>
          <button
            id="btn_simpan"
            type="button"
            class="btn btn-login btn-long remove-margin"
            @click="handleOnClick"
            :disabled="!listAkun || isLoading"
          >
            Buat Tagihan {{ formatRupiah(hargaLengkap) }}
          </button>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import Select2 from "v-select2-component";
import FieldPromo from "../components/FieldPromo";

export default {
  name: "Pembayaran",
  components: {
    SOSlotBase,
    SOTitleBar,
    FieldPromo,
    Select2,
  },
  data() {
    return {
      selectedRadio: 1,
      dataAkun: [],
      listAkun: "",
      idJenis: this.$route.params.idjenis,
      dataPost: {},
      showAlert: true,
      kode_unik: 0,
      page: {
        title: "Informasi Pembayaran",
        loading: false,
        from: "training.pay",
      },
    };
  },
  async mounted() {
    await this.getAkun();
    this.formJadwal.pembayaran.metode_pembayaran = this.selectedRadio;
  },
  computed: {
    ...mapGetters(moduleName, {
      dataOwner: "detailOwner",
      dataListTraining: "dataJenisTraining",
      detailJenisTraining: "detailJenisTraining",
      formJadwal: "formJadwal",
      hargaTraining: "hargaTraining",
      listAkunKeuangan: "listAkunKeuangan",
      trainingCreate: "trainingCreate",
      promo: "promo",
    }),
    isLoading() {
      return this.page.loading;
    },
    formattedHargaTraining() {
      return this.hargaTraining.harga.toLocaleString("id-ID");
    },
    hargaAdminDisplay() {
      const harga = this.hargaTraining.harga;
      return (harga * 0.2) / 100;
    },
    hargaLengkap() {
      let diskon = this.hargaTraining.harga * (this.promo[0].diskon / 100);
      const harga = this.hargaTraining.harga - diskon;
      if (this.formJadwal.pembayaran.metode_pembayaran == 1) {
        this.kode_unik = Math.floor(Math.random() * 99) + 1;
        return harga + this.kode_unik;
      } else if (this.formJadwal.pembayaran.metode_pembayaran == 2) {
        return harga + (harga * 0.2) / 100;
      } else {
        return 0;
      }
    },
  },

  methods: {
    ...mapActions({
      getDetailOwner: `${moduleName}/getDetailOwner`,
      getListJenisTraining: `${moduleName}/getListJenisTraining`,
      getDetailJenisTraining: `${moduleName}/getDetailJenisTraining`,
      getAkunKeuangan: `${moduleName}/getAkunKeuangan`,
      postDataTrainingCreate: `${moduleName}/postDataTrainingCreate`,
    }),

    closeAlert() {
      this.formJadwal.pembayaran.kode_promo = "";
      this.promo[0].diskon = 0;
      this.promo[0].available = false;
    },

    async init() {
      await this.getListJenisTraining();
      await this.getRiwayatTraining();
    },
    async getAkun() {
      let res = await this.getAkunKeuangan();
      if (res) {
        for (let i = 0; i < this.listAkunKeuangan.length; i++) {
          this.dataAkun.push({
            id: this.listAkunKeuangan[i].idakun,
            text: this.listAkunKeuangan[i].nama_akun,
          });
        }
      }
    },
    async handleOnClick() {
      // let kode_unik = null;
      // if (this.formJadwal.pembayaran.metode_pembayaran === 1) {
      //   let kode_unik = Math.floor(Math.random() * 99) + 1;
      // }
      this.setLoading(true);
      if (this.idJenis == "paid_online") {
        this.dataPost = {
          id_jenis_training: this.formJadwal.id_jenis_training,
          jadwal_training: [
            {
              jadwal_mulai: this.formJadwal.jadwal_training[0].jadwal_mulai,
              jadwal_selesai: this.formJadwal.jadwal_training[0].jadwal_selesai,
              sesi: this.formJadwal.jadwal_training[0].sesi,
            },
            {
              jadwal_mulai: this.formJadwal.jadwal_training[1].jadwal_mulai,
              jadwal_selesai: this.formJadwal.jadwal_training[1].jadwal_selesai,
              sesi: this.formJadwal.jadwal_training[1].sesi,
            },
          ],
          nama_owner: this.formJadwal.nama_owner,
          no_telp: this.formJadwal.no_telp,
          pembayaran: {
            kode_promo: this.formJadwal.pembayaran.kode_promo,
            akun: this.listAkun,
            metode_pembayaran: this.formJadwal.pembayaran.metode_pembayaran,
            kode_unik: this.kode_unik,
          },
        };
      }

      if (this.idJenis != "paid_online") {
        this.dataPost = {
          id_jenis_training: this.formJadwal.id_jenis_training,
          jadwal_training: [
            {
              jadwal_mulai: this.formJadwal.jadwal_training[0].jadwal_mulai,
              jadwal_selesai: this.formJadwal.jadwal_training[0].jadwal_selesai,
              sesi: this.formJadwal.jadwal_training[0].sesi,
            },
          ],
          nama_owner: this.formJadwal.nama_owner,
          no_telp: this.formJadwal.no_telp,
          pembayaran: {
            kode_promo: this.formJadwal.pembayaran.kode_promo,
            akun: this.listAkun,
            metode_pembayaran: this.formJadwal.pembayaran.metode_pembayaran,
            kode_unik: this.kode_unik,
          },
        };
      }

      let res = await this.postDataTrainingCreate(this.dataPost)
        .then((res) => {
          this.setLoading(false);
          if (!res.data) {
            this.$toast.error(res);
            this.$router.push({ name: "training.list" });
          } else {
            if (res.data.code === 200) {
              if (res.data.status) {
                this.$toast.success(res.data.msg);
                this.$router.push({
                  name: "detail.pembayaran",
                  params: { idTraining: res.data.data[0].id_training },
                });
              }
            }

            // this.setResponse(resulter.errorResult(msg));
          }
        })
        .catch((err) => {
          this.setLoading(false);
          this.$toast.error(err);
          // this.setResponse(resulter.errorResult(e));
        });
    },

    selectRadio(opsi_bayar) {
      this.formJadwal.pembayaran.metode_pembayaran = opsi_bayar;
    },
    back() {
      this.$router.go(-1);
    },
    setLoading(val) {
      this.page.loading = val;
    },
  },
};
</script>
